function rearrangeDetailsLayout() {
	const $detailsList = document.querySelector('.b-details-list');

	if (!$detailsList) {
		return;
	}

	const isDesktop = window.innerWidth >= 1024;
	const $summariesWrapper = $detailsList.querySelector('.b-details-list-summaries');
	const $descriptionsContainer = $detailsList.querySelector('.b-details-list-descriptions');

	if (isDesktop) {
		if ($descriptionsContainer) {
			return;
		}

		const $items = $detailsList.querySelectorAll('.b-details-list-item');

		$items.forEach($item => $item.classList.remove('is-active'));

		let activeIndex = 0;

		$items.forEach(($item, index) => {
			if ($item.hasAttribute('open')) {
				activeIndex = index;
			}
			$item.removeAttribute('open');
		});

		const $descriptions = Array.from($items).map($item =>
			$item.querySelector('.b-details-list-item-description')
		);

		const $newSummariesWrapper = document.createElement('div');
		$newSummariesWrapper.className = 'b-details-list-summaries';
		$items.forEach($item => $newSummariesWrapper.appendChild($item));

		const $newContainer = document.createElement('div');
		$newContainer.className = 'b-details-list-descriptions';

		$descriptions.forEach(($description, index) => {
			if (!$description) {
				return;
			}

			const $clone = $description.cloneNode(true);

			if (index === activeIndex) {
				$clone.classList.add('is-active');
			}
			$newContainer.appendChild($clone);
		});

		if ($items[activeIndex]) {
			$items[activeIndex].classList.add('is-active');
		}

		$items.forEach(($item, index) => {
			const $summary = $item.querySelector('.b-details-list-item-title');

			if (!$summary) {
				return;
			}

			$summary.addEventListener('mouseenter', function() {
				const clones = $newContainer.querySelectorAll('.b-details-list-item-description');

				clones.forEach(clone => clone.classList.remove('is-active'));
				$items.forEach(i => i.classList.remove('is-active'));

				if (clones[index]) {
					clones[index].classList.add('is-active');
				}
				$item.classList.add('is-active');
			});
		});

		$detailsList.appendChild($newSummariesWrapper);
		$detailsList.appendChild($newContainer);

		return;
	}

	if ($summariesWrapper) {
		const $items = $summariesWrapper.querySelectorAll('.b-details-list-item');

		let $activeItem = null;

		$items.forEach($item => {
			if ($item.classList.contains('is-active')) {
				$activeItem = $item;
			}
		});

		$items.forEach($item => {
			$detailsList.appendChild($item);
			$item.classList.remove('is-active');
			$item.removeAttribute('open');

			const $summary = $item.querySelector('.b-details-list-item-title');

			if ($summary) {
				$summary.replaceWith($summary.cloneNode(true));
			}
		});
		$summariesWrapper.remove();

		if ($activeItem) {
			$activeItem.setAttribute('open', '');
		}
	}

	if ($descriptionsContainer) {
		$descriptionsContainer.remove();
	}
}

document.addEventListener('DOMContentLoaded', function() {
	const $detailsList = document.querySelector('.b-details-list');

	if ($detailsList) {
		$detailsList.addEventListener('click', function(event) {
			if (window.innerWidth >= 1024) {
				return;
			}

			const $summary = event.target.closest('.b-details-list-item-title');

			if (!$summary) {
				return;
			}

			const $item = $summary.closest('.b-details-list-item');
			const isOpening = !$item.hasAttribute('open');

			const $allItems = $detailsList.querySelectorAll('.b-details-list-item');

			$allItems.forEach(other => {
				if (other !== $item) {
					other.removeAttribute('open');
				}
			});

			if (isOpening) {
				$item.setAttribute('open', '');
			}

			event.preventDefault();
		});
	}

	rearrangeDetailsLayout();
});
window.addEventListener('resize', rearrangeDetailsLayout);
